Librarian.TimeStampShareWindow = new Class({
    Extends: Librarian.Window,

    options: {
        id: "TimeStampShareWindow",
        height: 180,
        width: 350,
        title: "Share Moment",
        data: null,
        timestamp: "00:00:00"
    },

    className: "timestamp-share",
    minDuration: 0,
    maxDuration: null,

    bodyHtml: "\
        <div class='{{class}}-body'>\
            Select the checkbox below to share this video starting at the specified time. \
        </div> \
        <div class='{{class}}-input'> \
            <input type='checkbox' id='{{id}}-timestamp-checkbox' checked/> \
            <span>Start at: </span> \
            <input class='{{class}}-input-text' type='text' id='{{id}}-timestamp-duration' /> \
        </div> \
        <hr class='{{class}}-divider' /> \
        <div class='{{class}}-footer'> \
            <span class='pure-button pure-button-primary right' data-translation='continue' id='continueButton'>Continue</span> \
            <span class='pure-button right' data-translation='cancel' id='cancelButton'>Cancel</span> \
        </div> \
    ",

    initialize: function (options) {
        this.setOptions(options);

        this.options.id += (new Date().getTime());
        this.bodyTemplate = Handlebars.compile(this.bodyHtml);
        this.options.content = this.bodyTemplate({
            "id": this.options.id,
            "class": this.className
        });

        this.getVideoDetails();

        this.parent(this.options);
    },

    onWindowLoaded: function () {
        var id = this.options.id;

        var itemEl = this.getElement("cancelButton");
        if (itemEl) {
            itemEl.addOnClick(function() {
                this.fireEvent("sharetimestamp");
                this.close();
            }.bind(this));
        }

        itemEl = this.getElement("continueButton");
        if (itemEl) {
            itemEl.addOnClick(this.onContinue, this);
        }

        itemEl = this.getElement(id + "-timestamp-duration");
        if (itemEl) {
            if (this.options.timestamp != null && !isNaN(this.options.timestamp)) {
                itemEl.set("value", this.toHHMMSS(this.options.timestamp));
            } else {
                itemEl.set("value", this.toHHMMSS(this.minDuration));
            }
        }
    },

    onContinue: function() {
        var shareTimestamp = this.getElement(this.options.id + "-timestamp-checkbox").get("checked");
        var eventAttributes = null;

        if (shareTimestamp) {
            var timestamp = this.getElement(this.options.id + "-timestamp-duration").get("value");
            var data = this.options.data;

            if (!this.validate(timestamp)) {
                return false;
            }

            var timestampSeconds = this.toSeconds(timestamp);
            var timestamps = [
                {
                    contentId: data.fileid,
                    contentType: Librarian.contentType.file,
                    timestamp: timestampSeconds
                }
            ];

            eventAttributes =
            [
                [{
                    name: "video_timestamp",
                    value: JSON.stringify(timestamps)
                }]
            ];

        }

        this.fireEvent("sharetimestamp", eventAttributes);
        this.close();
    },

    getVideoDetails: function () {
        var self = this;
        var filename = this.options.data.fileid + '_low.mp4';
        var url = Librarian.path.videoStreamingUrl + filename;

        var videoEl = new Element("video", {
            src: url
        });

        videoEl.onloadedmetadata = function (e) {
            self.maxDuration = this.duration;
            videoEl.destroy();
        };

        document.body.append(videoEl);
    },

    validate: function(timestamp) {
        var seconds = this.toSeconds(timestamp);
        var min = this.toHHMMSS(this.minDuration);
        var max = this.maxDuration != null ? this.toHHMMSS(this.maxDuration) : "";

        if (isNaN(seconds)) {
            Librarian.Utils.error("Invalid timestamp format (00:00:00)");
            return false;
        }

        if (this.maxDuration != null && seconds > this.maxDuration) {
            Librarian.Utils.error("Timestamp should be between " + min + " and " + max);
            return false;
        }

        if (this.minDuration != null && seconds < this.minDuration) {
            Librarian.Utils.error("Timestamp should be between " + min + " and " + max);
            return false;
        }

        return true;
    },

    toHHMMSS: function (sec) {
        var sec_num = parseInt(sec, 10); // don't forget the second param
        var hours   = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);

        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        return hours+':'+minutes+':'+seconds;
    },

    toSeconds: function(timestamp) {
        var segments = timestamp.split(":");
        var magnitude = [1, 60, 60 * 60];
        var seconds = 0;

        for (var i = segments.length, counter = 0; i--;) {
            seconds += Number(segments[i]) * magnitude[counter];
            counter++;
        }

       return seconds;
    }
});
